import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ViewDatesQuery } from '../../../../../generated/graphql.generated';
import { ActionSource } from '../../../../state/action-sources';

import { RemarkSeverity } from './dispatch-calendar-remarks-dialog.state';

export const DispatchCalendarRemarksDialogActions = createActionGroup({
    source: ActionSource.DISPATCH_CALENDAR_REMARKS_DIALOG,
    events: {
        'Dialog Opened': props<{ date?: string | null }>(),
        'Dialog Closed': emptyProps(),
        'Load View Dates Success': props<{ viewDates: ViewDatesQuery['viewDates'] }>(),
        'Load View Dates Error': props<{ error: Error }>(),
        'Dates Selected': props<{ dates: (string | null)[] | null }>(),
        'Remark Text Input Changed': props<{ text: string }>(),
        'Severity Dropdown Changed': props<{ severity: RemarkSeverity }>(),
        'Add Remark Button Clicked': emptyProps(),
        'Edit Remark Button Clicked': props<{ remarkId: string }>(),
        'Edit Remark Cancelled': emptyProps(),
        'Delete Remark Button Clicked': props<{ remarkId: string }>(),
        'Save Button Clicked': emptyProps(),
        'Save Remarks Success': emptyProps(),
        'Save Remarks Error': props<{ error: Error }>(),
        'Cancel Button Clicked': emptyProps(),
    },
});
